import axios, { AxiosRequestConfig } from 'axios';

// ⚠️ CUTOVER (backend unificado `recreativa-api`): as 4 APIs legadas viraram UMA só.
// Para reverter ao legado, reaponte `baseURL` para as URLs comentadas abaixo:
//   api / apiNode → https://api2.arecreativa.com.br
//   apiPHP        → https://api.recreativa.com.br/api
//   apiWordle     → https://api-wordle.herokuapp.com
const baseURL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

export const TOKEN_KEY = '@Portal:token';

/** Lê o token NA HORA da requisição (login/logout sem recarregar a página). */
export function withAuthToken(config: AxiosRequestConfig): AxiosRequestConfig {
  const token = localStorage.getItem(TOKEN_KEY);
  config.headers = config.headers ?? {};
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  } else {
    delete config.headers.Authorization;
  }
  return config;
}

export const api = axios.create({ baseURL });
export const apiNode = axios.create({ baseURL });
export const apiPHP = axios.create({ baseURL });
export const apiWordle = axios.create({ baseURL });

api.interceptors.request.use(withAuthToken);
apiNode.interceptors.request.use(withAuthToken);
apiPHP.interceptors.request.use((config) =>
  config.url?.endsWith('planos') ? config : withAuthToken(config)
);

export default api;
